<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="offers-header">
  <div class="page-content-wider">
    <div class="my-lists-header-row">
      <div>
        <h1 class="offers-header-title">{{getString(getListHeaderTitleKey())}}</h1>
        {{getString(getListHeaderTextKey())}}
      </div>
    </div>
  </div>
</div>

<div class="page-content-wider">

  <div class="store-media-selectors-container">
    <div class="personal-lists-toolbar" *ngIf="isMyListsActive()">
      <div class="list-type-selector-container personal-lists-type-selector">
        <div class="list-selection-text">{{getString('listSelection')}}</div>
        <nav class="list-type-selector" aria-label="Lists">
          <div class="list-type-wrapper" *ngFor="let listType of getListTypes(); let i = index">
            <a class="list-type-item" [routerLink]="getListTypeUrl(listType)" [class.active]="isActiveListType(listType)">
              <span class="material-icons list-type-icon" aria-hidden="true">{{listType.icon}}</span>
              <span class="list-type-label"><span *ngFor="let labelPart of getListTypeLabelParts(listType)">{{labelPart}}</span></span>
            </a>
            <div class="headerDivider" *ngIf="i != getListTypes().length - 1"></div>
          </div>
        </nav>
      </div>
      <div class="store-media-selectors-content">
        <app-store-selector class="store-selector-container" [useBrandIcons]="true" (onStoreChanged)="storeChanged()"></app-store-selector>
        <app-media-selector class="media-selector-container" [selectedMediaType]="selectedMediaType" [mediaTypes]="mediaTypesForDisplay"
          [nolinks]="true" (onMediaChanged)="mediaChanged($event)">
        </app-media-selector>
        <div class="actions-selector-container" *ngIf="!showLoginRequired">
          <div class="actions-selection-text">{{getString('actions')}}</div>
          <div class="actions-icons-container">
            <button type="button" class="add-list-action" (click)="openCreateListModal()">
              <span class="material-icons action-icon">add_circle</span>
              <span class="action-name">{{getString('addNewList')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="store-media-selectors-content" *ngIf="!isMyListsActive()">
      <app-store-selector class="store-selector-container" [useBrandIcons]="true" (onStoreChanged)="storeChanged()"></app-store-selector>
      <app-media-selector class="media-selector-container" [selectedMediaType]="selectedMediaType" [mediaTypes]="mediaTypesForDisplay"
        [nolinks]="true" (onMediaChanged)="mediaChanged($event)">
      </app-media-selector>
    </div>
  </div>

  <div class="list-section-tabs" role="tablist" *ngIf="isPublicSectionActive()">
    <button type="button" role="tab" [attr.aria-selected]="isActiveListSection('curated')" [class.active]="isActiveListSection('curated')" (click)="selectListSection('curated')">
      {{getString('editorialLists')}}
    </button>
    <button type="button" role="tab" [attr.aria-selected]="isActiveListSection('community')" [class.active]="isActiveListSection('community')" (click)="selectListSection('community')">
      {{getString('communityLists')}}
    </button>
  </div>

  <div *ngIf="isMyListsActive() && showLoginRequired" class="my-lists-state">
    <h2>{{getString('myLists')}}</h2>
    <p>{{getString('myListsLoginRequired')}}</p>
  </div>

  <div *ngIf="isMyListsActive() && !showLoginRequired && isLoading" class="spinner-container txt-algn-cntr">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="isMyListsActive() && !showLoginRequired && !isLoading && hasError" class="my-lists-state">
    <p>{{getString('technicalProblems')}}</p>
    <button type="button" (click)="loadLists()">{{getString('reload')}}</button>
  </div>

  <div *ngIf="isMyListsActive() && !showLoginRequired && !isLoading && !hasError && lists.length === 0" class="my-lists-state">
    <h2>{{getString('myListsEmptyTitle')}}</h2>
    <p>{{getString('myListsEmptyText')}}</p>
  </div>

  <div *ngIf="isMyListsActive() && !showLoginRequired && !isLoading && !hasError && lists.length > 0" class="filters-container-test my-lists-sort-container">
    <div class="small-horizontal-border"></div>

    <div class="normal-filters">
      <div class="filter-test-mobile-sort">
        <app-dropdown class="dd-test" [label]="getString('sortBy')" [items]="sortingValues" [selectedItem]="sortKey" [right]="true" (onItemSelected)="sortChanged($event)"></app-dropdown>
      </div>
    </div>

    <div class="special-filter">
      <app-dropdown class="sort float-right dd" [selectedItemWidth]="'180px'" [title]="getString('sortBy')" [items]="sortingValues" [selectedItem]="sortKey" [right]="true" (onItemSelected)="sortChanged($event)"></app-dropdown>
    </div>
  </div>

  <div *ngIf="isMyListsActive() && !showLoginRequired && !isLoading && !hasError && lists.length > 0" class="my-lists-grid">
    <div class="my-list-card" *ngFor="let list of lists; let listIndex = index" (click)="openListDetail(list, $event)">
      <a class="card-link" [href]="getListDetailUrl(list)" (mousedown)="prepareListNavigation(list)" (touchstart)="prepareListNavigation(list)" (click)="openListDetail(list, $event)">
        <div class="card-content">
          <h2 class="card-title"><span class="card-title-part" *ngFor="let titlePart of getListTitleParts(list)">{{titlePart}}</span></h2>
          <div class="meta">{{getItemCount(list)}} {{getString('items')}}</div>
        </div>
        <div class="thumb-strip" [ngClass]="getThumbStripClass()" *ngIf="getThumbs(list).length > 0">
          <img *ngFor="let thumb of getThumbs(list)" [src]="thumb" alt="" (error)="showImagePlaceholder($event)">
        </div>
        <div class="thumb-strip empty-thumbs" [ngClass]="getThumbStripClass()" *ngIf="getThumbs(list).length === 0"></div>
        <span *ngIf="hasPublicValue(list)" class="visibility-badge" [class.public]="isPublicList(list)">
          {{isPublicList(list) ? getString('publicList') : getString('privateList')}}
        </span>
      </a>

      <div class="list-card-menu">
        <button type="button" class="menu-trigger" (click)="toggleListMenu(list, $event, getListMenuKey('my', '', 0, listIndex, list))" [title]="getString('more')">
          <span class="material-icons">more_vert</span>
        </button>
        <div class="dropdown-content dd-right" [class.dd-open]="isListMenuOpen(list, getListMenuKey('my', '', 0, listIndex, list))" [class.dd-close]="!isListMenuOpen(list, getListMenuKey('my', '', 0, listIndex, list))">
          <button type="button" class="dd-item" (click)="deleteList(list, $event)">{{getString('deleteList')}}</button>
          <button type="button" class="dd-item" (click)="editList(list, $event)">{{getString('editList')}}</button>
          <button type="button" class="dd-item" (click)="duplicateList(list, $event)">{{getString('duplicateList')}}</button>
          <button type="button" class="dd-item" (click)="shareListLink(list, $event)">{{getString('shareLink')}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="public-discovery" *ngIf="isPublicSectionActive() && !selectedPublicBucket">
    <div class="public-section" *ngIf="getActivePublicSection() as section">
      <div *ngIf="section.isLoading" class="spinner-container txt-algn-cntr">
        <app-spinner></app-spinner>
      </div>

      <div *ngIf="!section.isLoading && section.hasError" class="my-lists-state compact-state">
        <p>{{getString('technicalProblems')}}</p>
      </div>

      <div *ngIf="!section.isLoading && !section.hasError && !hasPublicBuckets(section)" class="my-lists-state compact-state public-empty-state">
        <span class="material-icons empty-state-icon" aria-hidden="true">playlist_add_check</span>
        <p>{{getString(section.key === 'community' ? 'noCommunityLists' : 'noPublicLists')}}</p>
      </div>

      <div class="public-bucket" *ngFor="let bucket of section.buckets; let bucketIndex = index">
        <button type="button" class="public-bucket-title" (click)="openPublicCategory(section, bucket)">
          <span>{{bucket.title}}</span>
          <span class="material-icons">chevron_right</span>
        </button>

        <app-horizontal-scroll>
          <div class="public-card-row">
            <div class="my-list-card public-list-card" *ngFor="let list of bucket.lists; let listIndex = index" (click)="openListDetail(list, $event)">
              <a class="card-link public-card-link" [href]="getListDetailUrl(list)" (mousedown)="prepareListNavigation(list)" (touchstart)="prepareListNavigation(list)" (click)="openListDetail(list, $event)">
                <div class="card-content">
                  <h2 class="card-title"><span class="card-title-part" *ngFor="let titlePart of getListTitleParts(list)">{{titlePart}}</span></h2>
                </div>
                <div class="thumb-strip" [ngClass]="getThumbStripClass()" *ngIf="getThumbs(list).length > 0">
                  <img *ngFor="let thumb of getThumbs(list)" [src]="thumb" alt="" (error)="showImagePlaceholder($event)">
                </div>
                <div class="thumb-strip empty-thumbs" [ngClass]="getThumbStripClass()" *ngIf="getThumbs(list).length === 0"></div>
                <div class="public-card-footer">
                  <div class="public-card-likes">
                    <span class="material-icons">favorite_border</span>
                    <span class="public-card-like-count">{{getPublicListLikeCount(list)}}</span>
                  </div>
                  <div class="public-card-author" *ngIf="hasPublicListAuthor(list) || hasPublicListAuthorImage(list)">
                    <img *ngIf="hasPublicListAuthorImage(list)" class="author-image" [src]="getPublicListAuthorImage(list)" alt="" (error)="showImagePlaceholder($event)">
                    <span *ngIf="!hasPublicListAuthorImage(list)" class="material-icons user-fallback">account_circle</span>
                    <span class="author-label" *ngIf="hasPublicListAuthor(list)">{{getPublicListAuthor(list)}}</span>
                    <span class="public-card-separator"></span>
                  </div>
                </div>
              </a>
              <div class="list-card-menu public-card-menu">
                <button type="button" class="menu-trigger" (click)="toggleListMenu(list, $event, getListMenuKey(section.key, bucket.id, bucketIndex, listIndex, list))" [title]="getString('more')">
                  <span class="material-icons">more_vert</span>
                </button>
                <div class="dropdown-content dd-right" [class.dd-open]="isListMenuOpen(list, getListMenuKey(section.key, bucket.id, bucketIndex, listIndex, list))" [class.dd-close]="!isListMenuOpen(list, getListMenuKey(section.key, bucket.id, bucketIndex, listIndex, list))">
                  <button type="button" class="dd-item" (click)="duplicateList(list, $event)">{{getString('duplicateList')}}</button>
                  <button type="button" class="dd-item" (click)="copyPublicListUrl(list, $event)">{{getString('shareLink')}}</button>
                </div>
              </div>
            </div>
          </div>
        </app-horizontal-scroll>
      </div>

      <div class="load-more-row" *ngIf="section.isLoadingMore">
        <app-spinner></app-spinner>
      </div>
    </div>
  </div>

  <div class="public-category-view" *ngIf="isPublicSectionActive() && selectedPublicBucket">
    <button type="button" class="back-to-public-lists" (click)="closePublicCategory(true)">
      <span>&lt; Back</span>
    </button>

    <h2 class="public-category-title" *ngIf="selectedPublicBucket && selectedPublicBucket.title">{{selectedPublicBucket.title}}</h2>

    <div *ngIf="isLoadingPublicCategory && publicCategoryLists.length === 0" class="spinner-container txt-algn-cntr">
      <app-spinner></app-spinner>
    </div>

    <div *ngIf="!isLoadingPublicCategory && publicCategoryError" class="my-lists-state compact-state">
      <p>{{getString('technicalProblems')}}</p>
    </div>

    <div *ngIf="!isLoadingPublicCategory && !publicCategoryError && publicCategoryLists.length === 0" class="my-lists-state compact-state public-empty-state">
      <span class="material-icons empty-state-icon" aria-hidden="true">playlist_add_check</span>
      <p>{{getString(selectedPublicSection && selectedPublicSection.key === 'community' ? 'noCommunityLists' : 'noPublicLists')}}</p>
    </div>

    <div *ngIf="publicCategoryLists.length > 0" class="my-lists-grid public-category-grid">
      <div class="my-list-card public-list-card" *ngFor="let list of publicCategoryLists; let listIndex = index" (click)="openListDetail(list, $event)">
        <a class="card-link public-card-link" [href]="getListDetailUrl(list)" (mousedown)="prepareListNavigation(list)" (touchstart)="prepareListNavigation(list)" (click)="openListDetail(list, $event)">
          <div class="card-content">
            <h2 class="card-title"><span class="card-title-part" *ngFor="let titlePart of getListTitleParts(list)">{{titlePart}}</span></h2>
          </div>
          <div class="thumb-strip" [ngClass]="getThumbStripClass()" *ngIf="getThumbs(list).length > 0">
            <img *ngFor="let thumb of getThumbs(list)" [src]="thumb" alt="" (error)="showImagePlaceholder($event)">
          </div>
          <div class="thumb-strip empty-thumbs" [ngClass]="getThumbStripClass()" *ngIf="getThumbs(list).length === 0"></div>
          <div class="public-card-footer">
            <div class="public-card-likes">
              <span class="material-icons">favorite_border</span>
              <span class="public-card-like-count">{{getPublicListLikeCount(list)}}</span>
            </div>
            <div class="public-card-author" *ngIf="hasPublicListAuthor(list) || hasPublicListAuthorImage(list)">
              <img *ngIf="hasPublicListAuthorImage(list)" class="author-image" [src]="getPublicListAuthorImage(list)" alt="" (error)="showImagePlaceholder($event)">
              <span *ngIf="!hasPublicListAuthorImage(list)" class="material-icons user-fallback">account_circle</span>
              <span class="author-label" *ngIf="hasPublicListAuthor(list)">{{getPublicListAuthor(list)}}</span>
              <span class="public-card-separator"></span>
            </div>
          </div>
        </a>
        <div class="list-card-menu public-card-menu">
          <button type="button" class="menu-trigger" (click)="toggleListMenu(list, $event, getListMenuKey(selectedPublicSection ? selectedPublicSection.key : activeListSection, selectedPublicBucket ? selectedPublicBucket.id : '', 0, listIndex, list))" [title]="getString('more')">
            <span class="material-icons">more_vert</span>
          </button>
          <div class="dropdown-content dd-right" [class.dd-open]="isListMenuOpen(list, getListMenuKey(selectedPublicSection ? selectedPublicSection.key : activeListSection, selectedPublicBucket ? selectedPublicBucket.id : '', 0, listIndex, list))" [class.dd-close]="!isListMenuOpen(list, getListMenuKey(selectedPublicSection ? selectedPublicSection.key : activeListSection, selectedPublicBucket ? selectedPublicBucket.id : '', 0, listIndex, list))">
            <button type="button" class="dd-item" (click)="copyPublicListUrl(list, $event)">{{getString('shareLink')}}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="load-more-row" *ngIf="publicCategoryHasMore">
      <button type="button" class="blue-button" [disabled]="isLoadingPublicCategory" (click)="loadMorePublicCategory()">
        {{isLoadingPublicCategory ? getString('loading') : getString('loadMore')}}
      </button>
    </div>
  </div>

</div>

<app-modal #createListModal class="create-list-modal" [title]="editingListId ? getString('editList') : getString('newList')" [longModal]="true"
  [confirmClose]="hasCreateListUnsavedChanges()"
  [closeConfirmationTitle]="getString('closeUnsavedListTitle')"
  [closeConfirmationText]="getString('closeUnsavedListConfirmation')"
  [closeConfirmationPositiveText]="getString('discardChanges')"
  [closeConfirmationNegativeText]="getString('keepEditing')">
  <div class="create-list-form">
    <div class="form-row">
      <label for="create-list-title">{{getString('listName')}}</label>
      <input id="create-list-title" type="text" [(ngModel)]="createListForm.title" maxlength="120">
    </div>

    <div class="form-row">
      <label for="create-list-description">{{getString('listDescription')}}</label>
      <textarea id="create-list-description" rows="3" [(ngModel)]="createListForm.description" maxlength="1000"></textarea>
    </div>

    <div class="modal-section">
      <h3>{{getString('addItem')}}</h3>
      <div class="item-search-box">
        <input type="text" [(ngModel)]="itemSearchTerm" (keyup)="onItemSearchKeyUp()" [placeholder]="getString('search')">
        <span *ngIf="isSearchingItems" class="small-status">{{getString('loading')}}</span>
      </div>

      <div class="item-suggestions" *ngIf="itemSuggestions.length > 0">
        <button type="button" class="suggestion-row" *ngFor="let suggestion of itemSuggestions" (click)="addSuggestion(suggestion)">
          <img *ngIf="getSuggestionThumbnail(suggestion)" [src]="getSuggestionThumbnail(suggestion)" alt="">
          <span class="suggestion-copy">
            <span class="suggestion-title">{{suggestion.title}}</span>
            <span class="suggestion-subtitle" *ngIf="getSuggestionSubtitle(suggestion)">{{getSuggestionSubtitle(suggestion)}}</span>
          </span>
        </button>
      </div>

      <div class="selected-items" *ngIf="selectedItems.length > 0">
        <div class="selected-items-title">{{getString('selectedItems')}}</div>
        <div class="selected-item" *ngFor="let item of selectedItems; let i = index" draggable="true" [attr.data-index]="i" [class.dragging]="draggedItemIndex === i"
          (dragstart)="onSelectedItemDragStart(i)" (dragover)="onSelectedItemDragOver($event)" (drop)="onSelectedItemDrop(i)" (dragend)="onSelectedItemDragEnd()">
          <span class="drag-handle material-icons" [title]="getString('dragToReorder')"
            (touchstart)="onSelectedItemTouchStart($event, i)" (touchmove)="onSelectedItemTouchMove($event)" (touchend)="onSelectedItemTouchEnd($event)" (touchcancel)="onSelectedItemTouchEnd($event)">drag_indicator</span>
          <span class="selected-item-thumb">
            <img *ngIf="getSuggestionThumbnail(item)" [src]="getSuggestionThumbnail(item)" alt="">
            <span *ngIf="isCreateListRanked()" class="ranking-badge">{{getCreateRankingNumber(i)}}</span>
          </span>
          <span>{{getSuggestionTitle(item)}}</span>
          <button type="button" (click)="removeSelectedItem(i)">{{getString('remove')}}</button>
        </div>
      </div>
      <div class="small-status" *ngIf="shouldShowCreateListItemValidation()">{{getString('customListItemsRequired')}}</div>
    </div>

    <div class="modal-section">
      <button type="button" class="tags-toggle" (click)="toggleTags()">
        <span>{{showTags ? getString('hideTags') : getString('addTags')}}</span>
        <span *ngIf="getSelectedTagCount() > 0" class="tag-count">{{getSelectedTagCount()}}</span>
        <span class="material-icons">{{showTags ? 'expand_less' : 'expand_more'}}</span>
      </button>
      <div *ngIf="showTags" class="tags-panel">
        <div *ngIf="isLoadingTags" class="small-status">{{getString('loading')}}</div>
        <div *ngIf="tagsError" class="small-status">{{getString('technicalProblems')}}</div>
        <div *ngIf="!isLoadingTags && !tagsError && tagGroups.length === 0" class="small-status">{{getString('noTagsAvailable')}}</div>
        <div class="tag-group" *ngFor="let group of tagGroups">
          <div class="tag-group-title">{{group.title}}</div>
          <div class="tag-chip-row">
            <button type="button" class="tag-chip" *ngFor="let tag of group.tags" [class.selected]="isTagSelected(tag.id)" (click)="toggleTag(tag.id)">
              {{tag.label}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-section two-column-options">
      <div>
        <h3>{{getString('settings')}}</h3>
        <label class="checkbox-row">
          <input type="checkbox" [ngModel]="createListForm.isPublic" (ngModelChange)="setCreateListPublic($event)">
          <span>{{getString('publicList')}}</span>
        </label>
        <label class="checkbox-row">
          <input type="checkbox" [(ngModel)]="createListForm.rankingMode">
          <span>{{getString('rankedList')}}</span>
        </label>
        <div class="ranking-order" *ngIf="isCreateListRanked()">
          <div class="option-label">{{getString('rankingOrder')}}</div>
          <label class="radio-pill" [class.selected]="createListForm.rankingOrder === 'asc'">
            <input type="radio" name="rankingOrder" value="asc" [(ngModel)]="createListForm.rankingOrder">
            <span>{{getString('ascending')}}</span>
          </label>
          <label class="radio-pill" [class.selected]="createListForm.rankingOrder === 'desc'">
            <input type="radio" name="rankingOrder" value="desc" [(ngModel)]="createListForm.rankingOrder">
            <span>{{getString('descending')}}</span>
          </label>
        </div>
      </div>

      <div>
        <h3>{{getString('notifications')}}</h3>
        <label class="checkbox-row">
          <input type="checkbox" [(ngModel)]="createListForm.priceDropNotification">
          <span>{{getString('priceDrops')}}</span>
        </label>
        <label class="checkbox-row">
          <input type="checkbox" [(ngModel)]="createListForm.fourKNotification">
          <span>{{getString('fourKUpgrades')}}</span>
        </label>
      </div>
    </div>

    <div class="red-text" *ngIf="createListError">{{getString('createListFailed')}}</div>

    <div class="modal-actions">
      <button type="button" class="cancel-button" (click)="closeCreateListModal()">
        {{getString('cancel')}}
      </button>
      <button type="button" class="blue-button" [disabled]="!canSaveCreateList()" (click)="saveCreateList()">
        {{isSavingList ? getString('saving') : getString('saveList')}}
      </button>
    </div>
  </div>
</app-modal>

<app-modal #deleteListConfirmationModal [title]="getString('deleteList')" [confirmationModal]="true"
[positiveText]="getString('deleteList')"
[negativeText]="getString('cancel')"
(onResult)="onDeleteListConfirmationResult($event)">
  <p>{{getString('deleteListConfirmation')}}</p>
</app-modal>

<app-scroll-top></app-scroll-top>
